import { DependentRelationship, Relationship } from 'src/shared/types/Common';
import { UserIconType } from '../constants/User';

export const getDependentRelationship = (
  dependents: { dependentRelationship: DependentRelationship }[] = [],
  isDependentOnly = false
) => {
  const type = getUserIcon(dependents, isDependentOnly);

  if (type === UserIconType.TWO) return Relationship.Spouse;

  if (type === UserIconType.MULTI) return Relationship.Child;

  return Relationship.Principal;
};

export const getUserIcon = (
  dependents: { dependentRelationship: DependentRelationship }[] = [],
  isDependentOnly = false
): UserIconType => {
  if (dependents.length === 0) return UserIconType.SINGLE;

  if (isDependentOnly) {
    const isMultiUsers = dependents.some(
      ({ dependentRelationship }) => dependentRelationship === DependentRelationship.Child
    );
    return isMultiUsers ? UserIconType.MULTI : UserIconType.TWO;
  }

  return UserIconType.SINGLE;
};
